




























































import {Vue, Component, Prop} from 'vue-property-decorator';
import axios from 'axios';
import i18nService from '@/services/i18n';
import GenView from '@/modules/budget/monitoring/input-forms/components/application41/genView.vue';
import TargetIndicators from '@/modules/budget/monitoring/input-forms/components/application41/targetIndicators.vue';

@Component({
    components: {
        'gen-view': GenView,
        'target-indicators': TargetIndicators,
    }
})
export default class FormData extends Vue {
    @Prop({
        required: true,
        default: () => []
    })
    private formDataList!: any[];
    @Prop({
        required: true,
        default: () => ({})
    })
    private gipForm!: any;
    @Prop({
        required: true,
        default: ''
    })
    private tr_path!:string;
    @Prop({
        required: true,
        default: () => ({})
    })
    private currForm!: any;
    @Prop({
        required: true,
        default: () => []
    })
    private investOptions!: any[];
    // Право редактирования карточки (application_41.vue, editAccess) — определяет,
    // показывать ли у наименования конечного результата карандаш (редактирование) или
    // глазик (просмотр), см. targetIndicators.vue.
    @Prop({ required: false, default: false })
    private editAccess!: boolean;
    // NTF.eAk.APPL41.01 — прокидывается вниз на обе вкладки для подсветки полей причины
    // отклонения после неудачной попытки сохранения (см. application_41.vue, saveData).
    @Prop({ required: false, default: false })
    private validationActive!: boolean;

    // currGipForm — НЕ отдельное состояние, а прокси к prop gipForm (.sync в родителе,
    // application_41.vue): переключение ГИП внутри карточки (‹далее›/дропдаун) раньше
    // писало только в локальную currGipForm, а Сохранить/Закрыть в application_41.vue
    // всегда читали исходный this.gipForm — при переключении на другой ГИП сохранялись
    // (и валидировались) данные ПЕРВОНАЧАЛЬНО открытого ГИП, а не того, что на экране.
    private get currGipForm(): any {
        return this.gipForm
    }
    private set currGipForm(value: any) {
        this.$emit('update:gip-form', value)
    }

    private currentView: number = 0;

    // Переключение на вкладку с первым найденным нарушением (NTF.eAk.APPL41.01) —
    // дёргается из application_41.vue через $refs.gip_data.focusTab(...).
    public focusTab(tab: number) {
        this.currentView = tab
    }

    private get hasGipDiscrepancies(): boolean {
        const info = this.currGipForm && this.currGipForm.gip_state_info
        if (!info) return false
        return (info.new_target_indicators || []).length > 0 || (info.deleted_target_indicators || []).length > 0
    }

    // Кнопка "Пожалуйста, обновите данные" в красной строке — синхронизирует
    // Application41TargetIndicators этого ГИП с текущим живым списком БИП/ЦИ
    // (удаляет исчезнувшие, создаёт снапшот для новых) и заменяет
    // currGipForm.target_indicators присланным результатом (тот же формат, что и при
    // обычной загрузке карточки).
    private async refreshTargetIndicators() {
        if (!this.currGipForm || !this.currGipForm.id) {
            return
        }
        await axios.post('/api-py/application/input-forms/41/gip-forms/target-indicators/refresh', {
            bip_form_id: this.currGipForm.id,
            currForm: this.currForm,
        }).then(resp => {
            this.currGipForm.target_indicators = resp.data.target_indicators
            this.currGipForm.gip_state_info = { new_target_indicators: [], deleted_target_indicators: [] }
        })
    }

    private get navLabel(): string {
        return i18nService.choose('далее', 'келесі', 'next');
    }

    private get currentGipFormIndex(): number {
        if (!this.currGipForm) {
            return -1
        }
        // Одна строка Application41BipForms — один ГИП (expense_code); bip_code теперь
        // список кодов БИП этого ГИП, а не скаляр, поэтому в ключе сравнения не участвует.
        return this.formDataList.findIndex((f: any) => f.expense_code === this.currGipForm.expense_code)
    }

    private get isFirstGipForm(): boolean {
        return this.currentGipFormIndex <= 0
    }

    private get isLastGipForm(): boolean {
        const index = this.currentGipFormIndex
        return index === -1 || index >= this.formDataList.length - 1
    }

    private prevGipForm() {
        const index = this.currentGipFormIndex
        if (index <= 0) {
            return
        }
        this.currGipForm = this.formDataList[index - 1]
    }

    private nextGipForm() {
        const index = this.currentGipFormIndex
        if (index === -1 || index >= this.formDataList.length - 1) {
            return
        }
        this.currGipForm = this.formDataList[index + 1]
    }

}
